import React from "react";

export default function ConfigSection(props) {
  return <div style={{ margin: "0.5rem 0" }}>{props.children}</div>;
}
